import { GenericRequest } from '@app/core/models/request-status.model';
import { Product } from '@b2b/features/product/core/utilities/product.model';

export enum FACET_TYPE {
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  SELECT = 'SELECT',
}

export interface Option {
  code: string;
  label: string;
}

export interface Facet {
  group: Facets;
  facets: ValuesFacets[];
}

export interface Facets {
  type?: FACET_TYPE;
  isExpanded?: boolean;
  code: string;
  name?: string;
  isLoading?: boolean;
  values?: ValuesFacets[];
}
export interface ValuesFacets {
  name: string;
  count?: number;
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalResults: number;
}

export interface GetProductListResponse {
  totalProducts: number;
  totalPages: number;
  currentPage: number;
  didYouMean?: string;
  products: Product[];
  facets?: GenericRequest<Facets[]>;
}

export interface ProductList {
  totalProducts: number;
  totalPages: number;
  currentPage: number;
  products: Product[];
  didYouMean?: string;
}

export interface ProductListState {
  title?: string;
  appliedFacets?: Facet[];
  facetGroups?: GenericRequest<Facets[]>;
  products?: GenericRequest<ProductList>;
  pagination?: Pagination;
}

export interface PLPParams {
  categoryID?: string;
  query?: string;
  text?: string;
  page?: number;
  limit?: number;
  params?: any;
}
